import React from 'react';
import { PressContainer, TitleWrapper, Title, PressWrapper, ReleaseWrapper, Header, Subheader, Button } from './PressElements';

const PressSection = ({ 
    title, target,
    pressHeader1, pressSubheader1, pressButton1, pressLink1,
    pressHeader2, pressSubheader2, pressButton2, pressLink2,
    pressHeader3, pressSubheader3, pressButton3, pressLink3,
    pressHeader4, pressSubheader4, pressButton4, pressLink4,
    pressHeader5, pressSubheader5, pressButton5, pressLink5,
    pressHeader6, pressSubheader6, pressButton6, pressLink6,
}) => {
    
    return (
        <>
            <PressContainer>
                <TitleWrapper>
                    <Title>
                        {title}
                    </Title>
                </TitleWrapper>
                <PressWrapper>
                    <ReleaseWrapper>
                        <Header>{pressHeader6}</Header>
                        <Subheader>Attochron is going to market with the World's Only Carrier-Grade Optical Wireless Communications&trade; -- a unique FSOC solution... <Button to={pressLink6} target={target}>{pressButton6}</Button></Subheader>
                    </ReleaseWrapper>
                    <ReleaseWrapper>
                        <Header>{pressHeader5}</Header>
                        <Subheader>{pressSubheader5}<Button to={pressLink5} target={target}>{pressButton5}</Button></Subheader>
                    </ReleaseWrapper>
                    <ReleaseWrapper>
                        <Header>{pressHeader4}</Header>
                        <Subheader>{pressSubheader4}<Button to={pressLink4} target={target}>{pressButton4}</Button></Subheader>
                    </ReleaseWrapper>
                    <ReleaseWrapper>
                        <Header>{pressHeader3}</Header>
                        <Subheader>{pressSubheader3}<Button to={pressLink3} target={target}>{pressButton3}</Button></Subheader>
                    </ReleaseWrapper>
                    <ReleaseWrapper>
                        <Header>{pressHeader2}</Header>
                        <Subheader>{pressSubheader2}<Button to={pressLink2} target={target}>{pressButton2}</Button></Subheader>
                    </ReleaseWrapper>
                    <ReleaseWrapper>
                        <Header>{pressHeader1}</Header>
                        <Subheader>{pressSubheader1}<Button to={pressLink1} target={target}>{pressButton1}</Button></Subheader>
                    </ReleaseWrapper>
                </PressWrapper>
            </PressContainer>
        </>
    )
}

export default PressSection;